"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const BoxComponentWithImg_1 = require("@app/routes/SpeechDevelopment/components/BoxComponentWithImg");
const Flex_1 = __importDefault(require("@app/components/common/Flex"));
const components_1 = require("@app/routes/SpeechDevelopment/exersices/FillGaps/components");
const getContentParts = (content) => content.split('_').reduce((acc, e, index, arr) => {
    acc.push(e);
    if (index !== arr.length - 1)
        acc.push(null);
    return acc;
}, []);
const isGap = (index) => index % 2 === 1;
const getGapIndex = (index) => (index - 1) / 2;
const initialSelectedIndex = 1;
const TextBoxWrapper = (0, styled_components_1.default)(BoxComponentWithImg_1.TextBox) `
  font-family: Arial, sans-serif;
  word-break: normal;
  overflow-wrap: normal;
  hyphens: none;
`;
function Content({ card, handleAnswer, isStarted, isPaused, exHandler, }) {
    var _a;
    const contentParts = (0, react_1.useMemo)(() => getContentParts(card.content), [card.content]);
    const [selectedIndex, setSelectedIndex] = (0, react_1.useState)(initialSelectedIndex);
    const [renderFilled, updateRenderFilled] = (0, react_1.useState)([]);
    const [answerFilled, updateAnswerFilled] = (0, react_1.useState)([]);
    const [letterCount, setLetterCount] = (0, react_1.useState)(0);
    console.log(card);
    const resetFilled = (0, react_1.useCallback)(() => {
        updateRenderFilled(getContentParts(card.content).map(() => null));
        updateAnswerFilled(getContentParts(card.content).map(() => null));
    }, [card.content]);
    const checkAnswersAndHandle = (0, react_1.useCallback)((gaps) => __awaiter(this, void 0, void 0, function* () {
        const checkablePieces = gaps.filter((_, index) => isGap(index));
        if (checkablePieces.every((e) => !!e)) {
            exHandler.saveAttempt(checkablePieces.join(', '));
            const isCorrect = yield handleAnswer(checkablePieces);
            if (!isCorrect && exHandler.recognizedWords.length + 1 !== exHandler.attemptMaxNumber) {
                resetFilled();
                setSelectedIndex(initialSelectedIndex);
            }
        }
    }), [handleAnswer, exHandler, resetFilled]);
    (0, react_1.useEffect)(() => {
        resetFilled();
        setSelectedIndex(initialSelectedIndex);
    }, [resetFilled]);
    (0, react_1.useEffect)(() => {
        if (typeof (card === null || card === void 0 ? void 0 : card.isCorrect) === 'boolean' && !(card === null || card === void 0 ? void 0 : card.isCorrect)) {
            updateRenderFilled((rFilled) => rFilled.map((e, index) => { var _a, _b; return isGap(index) ? (_b = (_a = card.correct_options) === null || _a === void 0 ? void 0 : _a[getGapIndex(index)]) === null || _b === void 0 ? void 0 : _b.right_word : e; }));
        }
    }, [card === null || card === void 0 ? void 0 : card.isCorrect, card.correct_options]);
    const handleLetterClick = (0, react_1.useCallback)((letter) => {
        if (!isStarted || isPaused)
            return;
        const gapIndex = getGapIndex(selectedIndex);
        const result = exHandler.checkOneGap(gapIndex, letter);
        const rightLetter = result ? letter : exHandler.getRightLetter(gapIndex);
        if (result || letterCount > 1) {
            if (selectedIndex !== renderFilled.length - 2 && result)
                exHandler.soundRight();
            updateRenderFilled((rFilled) => {
                rFilled[selectedIndex] = rightLetter;
                return [...rFilled];
            });
            if (result)
                updateAnswerFilled((aFilled) => {
                    aFilled[selectedIndex] = letter;
                    checkAnswersAndHandle(aFilled);
                    return [...aFilled];
                });
            setSelectedIndex((curr) => curr + 2);
            setLetterCount(0);
        }
        else {
            exHandler.soundTryAgain();
            setLetterCount((count) => count + 1);
        }
    }, [
        checkAnswersAndHandle,
        exHandler,
        renderFilled.length,
        isPaused,
        isStarted,
        selectedIndex,
        letterCount,
    ]);
    return (react_1.default.createElement(BoxComponentWithImg_1.Container, { direction: "column" },
        react_1.default.createElement(BoxComponentWithImg_1.Box, null,
            react_1.default.createElement(TextBoxWrapper, null, contentParts.map((textPart, index) => index < contentParts.length - 1 && isGap(index) ? (react_1.default.createElement(components_1.Gap, { key: textPart + index, onClick: () => setSelectedIndex(index), selected: selectedIndex === index, filled: renderFilled[index], isCorrect: exHandler.checkOneGap(getGapIndex(index), answerFilled[index]) }, renderFilled[index] || '_')) : (textPart)))),
        react_1.default.createElement(Flex_1.default, { mt: "20px" }, (_a = card === null || card === void 0 ? void 0 : card.additional_words) === null || _a === void 0 ? void 0 : _a.map((letter) => (react_1.default.createElement(components_1.Letter, { disabled: !isStarted || isPaused, key: letter, onClick: () => handleLetterClick(letter) }, letter))))));
}
exports.Content = Content;
